/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_ORIGIN_OUTPUTS',
  PUT: 'UPDATE_ORIGIN_OUTPUTS',
  DELETE: 'DELETE_ORIGIN_OUTPUTS',
  RESET: 'RESET_ORIGIN_OUTPUTS',
  RELOAD: 'RELOAD_ORIGIN_OUTPUTS',
};

export const getDraftId = () => (`originOutputs-draft${new Date().valueOf()}`);

export const originOutputsReducer = (state = [], action) => {
  switch (action.type) {
    case types.POST:
      return [
        ...state,
        { ...action.payload },
      ];
    case types.PUT:
      return action.payload;
    case types.DELETE:
      const newValues = [...state];
      const index = newValues.indexOf(action.payload);
      newValues.splice(index, 1);
      return newValues;
    case types.RELOAD:
      return action.payload;
    case types.RESET:
      return [];
    default:
      return state;
  }
};
